import CheckBoxItemList from "../../../../components/checkboxItemList/CheckBoxItemList";
import { IDeliveryItem } from "../../../../models/deliveryItem";
import CheckBoxDeliveryItem from "./CheckBoxDeliveryItem";

interface CheckBoxDeliveryItemListProps {
  items: IDeliveryItem[];
  selectedItems: IDeliveryItem[];
  setSelectedItems: (items: IDeliveryItem[]) => void;
  onCheckBoxChange: () => void;
}

const CheckBoxDeliveryItemList = (props: CheckBoxDeliveryItemListProps) => {
  const { items, selectedItems, setSelectedItems, onCheckBoxChange } = props;

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: IDeliveryItem,
  ) => {
    const { checked } = event.target;

    if (checked) {
      setSelectedItems([...selectedItems, item]);
    } else {
      setSelectedItems(
        selectedItems.filter((selectedItem) => selectedItem.id !== item.id),
      );
    }

    onCheckBoxChange();
  };

  return (
    <CheckBoxItemList listCount={items.length}>
      {items.map((item) => (
        <CheckBoxDeliveryItem
          key={item.id}
          deliveryItem={item}
          selectedItems={selectedItems}
          handleChange={handleChange}
        />
      ))}
    </CheckBoxItemList>
  );
};

export default CheckBoxDeliveryItemList;
